import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useRoutes } from "react-router-dom";
import getRoutes from "./routes";
import { routes } from "./helpers/constants";

const App = () => {
  const location = useLocation();
  const localSUser = JSON.parse(localStorage.getItem("user"));
  const { user } = useSelector((state) => state.userReducer);
  const routing = useRoutes(getRoutes(localSUser ? user : null));

  useEffect(() => {
    const path = location.pathname;
    const loginRoute = localStorage.getItem("loginRoute");
    if (path.includes("login")) {
      localStorage.setItem("loginRoute", path);
    } else if (user && !loginRoute) {
      const prevRoute = `/${user?.user_role?.toLowerCase()}-login`;
      const defaultRoute =
        user?.user_role !== "ADMIN" ? routes.login : prevRoute;
      localStorage.setItem("loginRoute", defaultRoute);
    }
  }, [location.pathname, user]);

  return <>{routing}</>;
};

export default App;
